import { HousekeepingPlanAccumulatorViewStore } from '@yard/pages/YardSetup/stores/housekeeping-plan-accumulator.view-store'
import { YardViewStore } from '@yard/pages/YardSetup/stores/yard.view-store'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { YardLeftDrawer } from '../../molecules/YardLeftDrawer'
import { HousekeepingPlanAccumulator } from './HousekeepingPlanAccumulator'

interface Props {
  yardViewStore: YardViewStore
  housekeepingPlanAccumulatorViewStore: HousekeepingPlanAccumulatorViewStore
}

export const HousekeepingPlanAccumulatorDrawer: FC<Props> = observer(props => {
  const { yardViewStore, housekeepingPlanAccumulatorViewStore } = props

  return (
    <YardLeftDrawer
      open={housekeepingPlanAccumulatorViewStore.isAccumulatorOpen && yardViewStore.isViewMode}
      onClose={() => housekeepingPlanAccumulatorViewStore.deactivate()}
      fullHeight
    >
      <HousekeepingPlanAccumulator viewStore={housekeepingPlanAccumulatorViewStore} />
    </YardLeftDrawer>
  )
})
